import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import deTranslation from './locales/de/translation.json'
import enTranslation from './locales/en/translation.json'

export const DEFAULT_LOCALE = 'en'
export const SUPPORTED_LOCALES = ['en', 'de'] as const
export type SupportedLanguages = (typeof SUPPORTED_LOCALES)[number]

const resources: Record<
  SupportedLanguages,
  { translation: Record<string, unknown> }
> = {
  de: {
    translation: deTranslation,
  },
  en: {
    translation: enTranslation,
  },
}

if (!i18n.isInitialized) {
  if (typeof window !== 'undefined') {
    i18n.use(LanguageDetector)
  }

  i18n.use(initReactI18next)

  void i18n.init({
    resources,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    defaultNS: 'translation',
    ns: ['translation'],
    keySeparator: '.',
    nsSeparator: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'lang',
      caches: [],
    },
    react: {
      useSuspense: false,
    },
  })
}

export default i18n
